import React, { useState } from "react";
import "../../DealApproval.scss";
import CustomSelect from "../../../../components/CustomSelect/CustomSelect";
import CustomInput from "../../../../components/CustomInput/Input";
import { isValidMeaningfulData } from "../helpers";

const MetricsForm = ({ itemIndex, blockItem, prefixOptions = [], suffixOptions = [], onUpdateBlockItem, onDeleteBlockItem }) => {
    const [metricTitleError, setMetricTitleError] = useState("");
    const defaultPrefix = prefixOptions[0]?.optionValue || "";
    const defaultSuffix = suffixOptions[0]?.optionValue || "";

    const handleMetricTitleChange = (e) => {
        const value = e.target.value;
        onUpdateBlockItem(itemIndex, "metricTitle", value);
        
        const trimmedValue = value.trim();
        let error = "";
        
        if (trimmedValue) {
            if (trimmedValue.length < 3) {
                error = "Metrics title must be at least 3 characters.";
            } else if (!isValidMeaningfulData(trimmedValue)) {
                error = "Please enter a valid and meaningful data.";
            }
        }
        
        setMetricTitleError(error);
    };

    return (
        <>
            <div className="metric-header-row">
                <label>Metrics Title <span className="required-mark">*</span></label>
                <button
                    type="button"
                    className="card-delete-text-btn"
                    onClick={() => onDeleteBlockItem(itemIndex)}
                >
                    Delete
                </button>
            </div>
            <input
                type="text"
                placeholder="Enter Title for this metric block..."
                value={blockItem.metricTitle || ""}
                maxLength={300}
                onChange={handleMetricTitleChange}
                className={metricTitleError ? "input-error" : ""}
            />
            <div className="error-counter-row">
                {metricTitleError ? <p className="form-error-text">{metricTitleError}</p> : <span className="error-placeholder" />}
                <span className="char-counter-text">{(blockItem.metricTitle || "").length}/300</span>
            </div>
            {(blockItem.metricTitle || "").length >= 300 && <p className="char-limit-note">Max 300 characters reached</p>}

            <div className="metrics-row">
                <div className="inline-field small-field">
                    <label>Prefix</label>
                    <CustomSelect
                        options={prefixOptions.map((opt) => ({ value: opt.optionValue, label: opt.optionLabel }))}
                        value={blockItem.prefix || defaultPrefix}
                        onChange={(value) => onUpdateBlockItem(itemIndex, "prefix", value)}
                    />
                </div>

                <div className="inline-field value-field">
                    <label>Value <span className="required-mark">*</span></label>
                    <CustomInput
                        type="number"
                        placeholder="Enter a value..."
                        value={blockItem.value || ""}
                        maxLength={15}
                        onChange={(e) => onUpdateBlockItem(itemIndex, "value", e.target.value.replace(/\D/g, ""))}
                        onKeyDown={(e) => {
                            if (["e", "E", "+", "-", "."].includes(e.key)) e.preventDefault();
                        }}
                    />
                    <span className="char-counter-text">{(String(blockItem.value || "")).length}/15</span>
                    {(String(blockItem.value || "")).length >= 15 && <p className="char-limit-note">Max 15 digits reached</p>}
                </div>

                <div className="inline-field small-field">
                    <label>Suffix</label>
                    <CustomSelect
                        options={suffixOptions.map((opt) => ({ value: opt.optionValue, label: opt.optionLabel }))}
                        value={blockItem.suffix || defaultSuffix}
                        onChange={(value) => onUpdateBlockItem(itemIndex, "suffix", value)}
                    />
                </div>
            </div>
        </>
    );
};

export default MetricsForm;
